// extracted by mini-css-extract-plugin
module.exports = {"upcomingEpisode":"fp","comingSoon":"fq","isRental":"fr","startDate":"fs","upcomingTitle":"ft","comingSoonTitle":"fu","startDateTitle":"fv","available":"fw"};